import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, ChevronRight, Check, Crown } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
type PlanId = 'pro' | 'elite';
const plans = {
  pro: {
    id: 'pro' as PlanId,
    name: 'Padel Zurdo Pro',
    price: '19.990',
    oldPrice: '49.990',
    url: 'https://checkout.ebookpoint.shop/cart/59466975805521:1',
    tagline: '6 Tomos + 3 Bonos'
  },
  elite: {
    id: 'elite' as PlanId,
    name: 'Padel Zurdo Pro ELITE',
    price: '27.990',
    oldPrice: '69.990',
    url: 'https://checkout.ebookpoint.shop/cart/59474337431633:1',
    tagline: 'Todo lo anterior + Bonos ELITE'
  }
};
export function Pricing() {
  const [selected, setSelected] = useState<PlanId>('elite');
  const current = plans[selected];
  return <section id="compra" className="py-20 px-4 bg-brand-black relative" data-id="element-76">
      <div className="max-w-4xl mx-auto" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card rounded-3xl p-6 md:p-10 text-center text-white shadow-2xl relative overflow-hidden border border-brand-green/20" data-id="element-78">
          <div className="absolute top-0 right-0 w-64 h-64 bg-brand-green/15 rounded-full blur-[80px]" data-id="element-79"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-green/15 rounded-full blur-[80px]" data-id="element-80"></div>

          <div className="relative z-10" data-id="element-81">
            <h2 className="font-display text-2xl md:text-4xl uppercase mb-3" data-id="element-82">
              Empezá a ganar <span className="text-brand-green" data-id="element-83">hoy mismo</span>
            </h2>
            <p className="font-body text-sm md:text-base text-gray-300 mb-5 max-w-2xl mx-auto" data-id="element-84">
              Elegí tu plan y obtené acceso inmediato.
            </p>

            <CountdownTimer data-id="element-85" />

            {/* Plan options */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-3xl mx-auto mb-5" data-id="element-86">
              {/* PRO */}
              <button type="button" onClick={() => setSelected('pro')} className={`text-left rounded-xl p-4 border-2 transition-all relative ${selected === 'pro' ? 'border-brand-green bg-brand-black' : 'border-white/10 bg-brand-black/50 hover:border-brand-green/40'}`} data-id="element-87">
                <div className="flex items-start justify-between gap-2 mb-2" data-id="element-88">
                  <div data-id="element-89">
                    <p className="font-display text-sm md:text-base text-white uppercase leading-tight" data-id="element-90">
                      {plans.pro.name}
                    </p>
                    <p className="font-body text-[11px] text-gray-400 mt-0.5" data-id="element-91">
                      {plans.pro.tagline}
                    </p>
                  </div>
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selected === 'pro' ? 'border-brand-green bg-brand-green' : 'border-white/30'}`} data-id="element-92">
                    {selected === 'pro' && <Check className="w-3 h-3 text-brand-black" strokeWidth={3} data-id="element-93" />}
                  </div>
                </div>
                <div className="flex items-baseline gap-1.5" data-id="element-94">
                  <span className="font-body text-gray-500 line-through text-xs" data-id="element-95">
                    ${plans.pro.oldPrice}
                  </span>
                  <span className="font-display text-2xl text-white" data-id="element-96">
                    ${plans.pro.price}
                  </span>
                  <span className="font-body text-[10px] text-brand-green" data-id="element-97">
                    ARS
                  </span>
                </div>
              </button>

              {/* ELITE */}
              <button type="button" onClick={() => setSelected('elite')} className={`text-left rounded-xl p-4 border-2 transition-all relative ${selected === 'elite' ? 'border-brand-green bg-brand-black' : 'border-white/10 bg-brand-black/50 hover:border-brand-green/40'}`} data-id="element-98">
                <div className="absolute -top-2.5 right-3 bg-brand-green text-brand-black font-display text-[10px] px-2 py-0.5 rounded-full flex items-center gap-1" data-id="element-99">
                  <Crown className="w-3 h-3" data-id="element-100" />
                  MÁS ELEGIDO
                </div>
                <div className="flex items-start justify-between gap-2 mb-2" data-id="element-101">
                  <div data-id="element-102">
                    <p className="font-display text-sm md:text-base text-white uppercase leading-tight" data-id="element-103">
                      {plans.elite.name}
                    </p>
                    <p className="font-body text-[11px] text-gray-400 mt-0.5" data-id="element-104">
                      {plans.elite.tagline}
                    </p>
                  </div>
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center shrink-0 ${selected === 'elite' ? 'border-brand-green bg-brand-green' : 'border-white/30'}`} data-id="element-105">
                    {selected === 'elite' && <Check className="w-3 h-3 text-brand-black" strokeWidth={3} data-id="element-106" />}
                  </div>
                </div>
                <div className="flex items-baseline gap-1.5 mb-2" data-id="element-107">
                  <span className="font-body text-gray-500 line-through text-xs" data-id="element-108">
                    ${plans.elite.oldPrice}
                  </span>
                  <span className="font-display text-2xl text-white" data-id="element-109">
                    ${plans.elite.price}
                  </span>
                  <span className="font-body text-[10px] text-brand-green" data-id="element-110">
                    ARS
                  </span>
                </div>
                <ul className="space-y-1 mt-2 pt-2 border-t border-white/10" data-id="element-111">
                  <li className="flex items-start gap-1.5 text-[11px] text-gray-300 font-body" data-id="element-112">
                    <Check className="w-3 h-3 text-brand-green shrink-0 mt-0.5" data-id="element-113" />
                    <span data-id="element-114">
                      <strong className="text-brand-green" data-id="element-115">Bono ELITE:</strong>{' '}
                      Lectura táctica de partido
                    </span>
                  </li>
                  <li className="flex items-start gap-1.5 text-[11px] text-gray-300 font-body" data-id="element-116">
                    <Check className="w-3 h-3 text-brand-green shrink-0 mt-0.5" data-id="element-117" />
                    <span data-id="element-118">
                      <strong className="text-brand-green" data-id="element-119">Bono ELITE:</strong>{' '}
                      Padel Performance 60 días
                    </span>
                  </li>
                  <li className="flex items-start gap-1.5 text-[11px] text-gray-300 font-body" data-id="element-120">
                    <Check className="w-3 h-3 text-brand-green shrink-0 mt-0.5" data-id="element-121" />
                    <span data-id="element-122">
                      <strong className="text-brand-green" data-id="element-123">Bono ELITE:</strong>{' '}
                      Errores de amateur + decisiones de PRO
                    </span>
                  </li>
                </ul>
              </button>
            </div>

            <p className="font-body text-brand-green font-medium text-xs mb-4" data-id="element-124">
              Pago único · Acceso de por vida.
            </p>

            <a href={current.url} className="inline-flex items-center justify-center gap-2 bg-brand-green hover:bg-brand-darkGreen text-brand-black font-display text-lg md:text-xl py-4 px-8 rounded-xl transition-all transform hover:scale-105 hover:shadow-xl hover:shadow-brand-green/30 w-full md:w-auto mb-5" data-id="element-125">
              QUIERO USAR MI ZURDA COMO VENTAJA
              <ChevronRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-126" />
            </a>

            <div className="flex flex-col md:flex-row items-center justify-center gap-4 text-xs font-body text-gray-400" data-id="element-127">
              <div className="flex items-center gap-2" data-id="element-128">
                <ShieldCheck className="w-4 h-4 text-brand-green" data-id="element-129" />
                <span data-id="element-130">Garantía de satisfacción</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-131">
                <Lock className="w-4 h-4 text-brand-green" data-id="element-132" />
                <span data-id="element-133">Pago 100% seguro</span>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}